import {isFilled} from '@prismicio/client'
import type {EventDocument} from 'prismicio-types'
import {ButtonV2} from 'src/common/ButtonV2'

type Props = {
  data: EventDocument['data']
  className?: string
}

export const ActionButton = ({data, className}: Props) => {
  const handleScrollToForm = () => {
    const formSection = document.getElementById('sign-up-section')

    if (formSection) {
      formSection.scrollIntoView({behavior: 'smooth', block: 'start'})
    }
  }

  return (
    isFilled.keyText(data.cta_button_text) &&
    data.event_type !== 'On demand' && (
      <ButtonV2
        className={className}
        border={false}
        variant="primary"
        onClick={handleScrollToForm}
        trackingData={{
          mktgId: 'scroll-to-register-form',
          location: 'src/Event/components/Hero/index.tsx',
          dataType: 'register-scroll-button',
          pageName: 'event-page-hero',
          label: data.cta_button_text,
        }}
      >
        {data.cta_button_text}
      </ButtonV2>
    )
  )
}
